export const timezones = [
    {
        value: 'Africa/Abidjan',
        label: 'Africa/Abidjan (GMT+0)',
        hint: 'Абиджан, Кот-д’Ивуар'
    },
    {
        value: 'Africa/Accra',
        label: 'Africa/Accra (GMT+0)',
        hint: 'Аккра, Гана'
    },
    {
        value: 'Africa/Addis_Ababa',
        label: 'Africa/Addis_Ababa (GMT+3)',
        hint: 'Аддис-Абеба, Эфиопия'
    },
    {
        value: 'Africa/Algiers',
        label: 'Africa/Algiers (GMT+1)',
        hint: 'Алжир, Алжир'
    },
    {
        value: 'Africa/Asmera',
        label: 'Africa/Asmera (GMT+3)',
        hint: 'Асмэра, Эритрея'
    },
    {
        value: 'Africa/Bamako',
        label: 'Africa/Bamako (GMT+0)',
        hint: 'Бамако, Мали'
    },
    {
        value: 'Africa/Bangui',
        label: 'Africa/Bangui (GMT+1)',
        hint: 'Банги, Центрально-Африканская Республика'
    },
    {
        value: 'Africa/Banjul',
        label: 'Africa/Banjul (GMT+0)',
        hint: 'Банжул, Гамбия'
    },
    {
        value: 'Africa/Bissau',
        label: 'Africa/Bissau (GMT+0)',
        hint: 'Бисау, Гвинея-Бисау'
    },
    {
        value: 'Africa/Blantyre',
        label: 'Africa/Blantyre (GMT+2)',
        hint: 'Блантайр, Малави'
    },
    {
        value: 'Africa/Brazzaville',
        label: 'Africa/Brazzaville (GMT+1)',
        hint: 'Браззавиль, Конго - Браззавиль'
    },
    {
        value: 'Africa/Bujumbura',
        label: 'Africa/Bujumbura (GMT+2)',
        hint: 'Бужумбура, Бурунди'
    },
    {
        value: 'Africa/Cairo',
        label: 'Africa/Cairo (GMT+3)',
        hint: 'Каир, Египет'
    },
    {
        value: 'Africa/Casablanca',
        label: 'Africa/Casablanca (GMT+1)',
        hint: 'Касабланка, Марокко'
    },
    {
        value: 'Africa/Ceuta',
        label: 'Africa/Ceuta (GMT+2)',
        hint: 'Сеута, Испания'
    },
    {
        value: 'Africa/Conakry',
        label: 'Africa/Conakry (GMT+0)',
        hint: 'Конакри, Гвинея'
    },
    {
        value: 'Africa/Dakar',
        label: 'Africa/Dakar (GMT+0)',
        hint: 'Дакар, Сенегал'
    },
    {
        value: 'Africa/Dar_es_Salaam',
        label: 'Africa/Dar_es_Salaam (GMT+3)',
        hint: 'Дар-эс-Салам, Танзания'
    },
    {
        value: 'Africa/Djibouti',
        label: 'Africa/Djibouti (GMT+3)',
        hint: 'Джибути, Джибути'
    },
    {
        value: 'Africa/Douala',
        label: 'Africa/Douala (GMT+1)',
        hint: 'Дуала, Камерун'
    },
    {
        value: 'Africa/El_Aaiun',
        label: 'Africa/El_Aaiun (GMT+1)',
        hint: 'Эль-Аюн, Западная Сахара'
    },
    {
        value: 'Africa/Freetown',
        label: 'Africa/Freetown (GMT+0)',
        hint: 'Фритаун, Сьерра-Леоне'
    },
    {
        value: 'Africa/Gaborone',
        label: 'Africa/Gaborone (GMT+2)',
        hint: 'Габороне, Ботсвана'
    },
    {
        value: 'Africa/Harare',
        label: 'Africa/Harare (GMT+2)',
        hint: 'Хараре, Зимбабве'
    },
    {
        value: 'Africa/Johannesburg',
        label: 'Africa/Johannesburg (GMT+2)',
        hint: 'Йоханнесбург, Южно-Африканская Республика'
    },
    {
        value: 'Africa/Juba',
        label: 'Africa/Juba (GMT+2)',
        hint: 'Джуба, Южный Судан'
    },
    {
        value: 'Africa/Kampala',
        label: 'Africa/Kampala (GMT+3)',
        hint: 'Кампала, Уганда'
    },
    {
        value: 'Africa/Khartoum',
        label: 'Africa/Khartoum (GMT+2)',
        hint: 'Хартум, Судан'
    },
    {
        value: 'Africa/Kigali',
        label: 'Africa/Kigali (GMT+2)',
        hint: 'Кигали, Руанда'
    },
    {
        value: 'Africa/Kinshasa',
        label: 'Africa/Kinshasa (GMT+1)',
        hint: 'Киншаса, Конго - Киншаса'
    },
    {
        value: 'Africa/Lagos',
        label: 'Africa/Lagos (GMT+1)',
        hint: 'Лагос, Нигерия'
    },
    {
        value: 'Africa/Libreville',
        label: 'Africa/Libreville (GMT+1)',
        hint: 'Либревиль, Габон'
    },
    {
        value: 'Africa/Lome',
        label: 'Africa/Lome (GMT+0)',
        hint: 'Ломе, Того'
    },
    {
        value: 'Africa/Luanda',
        label: 'Africa/Luanda (GMT+1)',
        hint: 'Луанда, Ангола'
    },
    {
        value: 'Africa/Lubumbashi',
        label: 'Africa/Lubumbashi (GMT+2)',
        hint: 'Лубумбаши, Конго - Киншаса'
    },
    {
        value: 'Africa/Lusaka',
        label: 'Africa/Lusaka (GMT+2)',
        hint: 'Лусака, Замбия'
    },
    {
        value: 'Africa/Malabo',
        label: 'Africa/Malabo (GMT+1)',
        hint: 'Малабо, Экваториальная Гвинея'
    },
    {
        value: 'Africa/Maputo',
        label: 'Africa/Maputo (GMT+2)',
        hint: 'Мапуту, Мозамбик'
    },
    {
        value: 'Africa/Maseru',
        label: 'Africa/Maseru (GMT+2)',
        hint: 'Масеру, Лесото'
    },
    {
        value: 'Africa/Mbabane',
        label: 'Africa/Mbabane (GMT+2)',
        hint: 'Мбабане, Эсватини'
    },
    {
        value: 'Africa/Mogadishu',
        label: 'Africa/Mogadishu (GMT+3)',
        hint: 'Могадишо, Сомали'
    },
    {
        value: 'Africa/Monrovia',
        label: 'Africa/Monrovia (GMT+0)',
        hint: 'Монровия, Либерия'
    },
    {
        value: 'Africa/Nairobi',
        label: 'Africa/Nairobi (GMT+3)',
        hint: 'Найроби, Кения'
    },
    {
        value: 'Africa/Ndjamena',
        label: 'Africa/Ndjamena (GMT+1)',
        hint: 'Нджамена, Чад'
    },
    {
        value: 'Africa/Niamey',
        label: 'Africa/Niamey (GMT+1)',
        hint: 'Ниамей, Нигер'
    },
    {
        value: 'Africa/Nouakchott',
        label: 'Africa/Nouakchott (GMT+0)',
        hint: 'Нуакшот, Мавритания'
    },
    {
        value: 'Africa/Ouagadougou',
        label: 'Africa/Ouagadougou (GMT+0)',
        hint: 'Уагадугу, Буркина-Фасо'
    },
    {
        value: 'Africa/Porto-Novo',
        label: 'Africa/Porto-Novo (GMT+1)',
        hint: 'Порто-Ново, Бенин'
    },
    {
        value: 'Africa/Sao_Tome',
        label: 'Africa/Sao_Tome (GMT+0)',
        hint: 'Сан-Томе, Сан-Томе и Принсипи'
    },
    {
        value: 'Africa/Tripoli',
        label: 'Africa/Tripoli (GMT+2)',
        hint: 'Триполи, Ливия'
    },
    {
        value: 'Africa/Tunis',
        label: 'Africa/Tunis (GMT+1)',
        hint: 'Тунис, Тунис'
    },
    {
        value: 'Africa/Windhoek',
        label: 'Africa/Windhoek (GMT+2)',
        hint: 'Виндхук, Намибия'
    },
    {
        value: 'America/Adak',
        label: 'America/Adak (GMT-9)',
        hint: 'Адак, Соединенные Штаты'
    },
    {
        value: 'America/Anchorage',
        label: 'America/Anchorage (GMT-8)',
        hint: 'Анкоридж, Соединенные Штаты'
    },
    {
        value: 'America/Anguilla',
        label: 'America/Anguilla (GMT-4)',
        hint: 'Ангилья, Ангилья'
    },
    {
        value: 'America/Antigua',
        label: 'America/Antigua (GMT-4)',
        hint: 'Антигуа, Антигуа и Барбуда'
    },
    {
        value: 'America/Araguaina',
        label: 'America/Araguaina (GMT-3)',
        hint: 'Арагуаина, Бразилия'
    },
    {
        value: 'America/Argentina/La_Rioja',
        label: 'America/Argentina/La_Rioja (GMT-3)',
        hint: 'Ла-Риоха, Аргентина'
    },
    {
        value: 'America/Argentina/Rio_Gallegos',
        label: 'America/Argentina/Rio_Gallegos (GMT-3)',
        hint: 'Рио-Гальегос, Аргентина'
    },
    {
        value: 'America/Argentina/Salta',
        label: 'America/Argentina/Salta (GMT-3)',
        hint: 'Сальта, Аргентина'
    },
    {
        value: 'America/Argentina/San_Juan',
        label: 'America/Argentina/San_Juan (GMT-3)',
        hint: 'Сан-Хуан, Аргентина'
    },
    {
        value: 'America/Argentina/San_Luis',
        label: 'America/Argentina/San_Luis (GMT-3)',
        hint: 'Сан-Луис, Аргентина'
    },
    {
        value: 'America/Argentina/Tucuman',
        label: 'America/Argentina/Tucuman (GMT-3)',
        hint: 'Тукуман, Аргентина'
    },
    {
        value: 'America/Argentina/Ushuaia',
        label: 'America/Argentina/Ushuaia (GMT-3)',
        hint: 'Ушуая, Аргентина'
    },
    {
        value: 'America/Aruba',
        label: 'America/Aruba (GMT-4)',
        hint: 'Аруба, Аруба'
    },
    {
        value: 'America/Asuncion',
        label: 'America/Asuncion (GMT-3)',
        hint: 'Асунсьон, Парагвай'
    },
    {
        value: 'America/Bahia',
        label: 'America/Bahia (GMT-3)',
        hint: 'Баия, Бразилия'
    },
    {
        value: 'America/Bahia_Banderas',
        label: 'America/Bahia_Banderas (GMT-6)',
        hint: 'Баия-де-Бандерас, Мексика'
    },
    {
        value: 'America/Barbados',
        label: 'America/Barbados (GMT-4)',
        hint: 'Barbados, Барбадос'
    },
    {
        value: 'America/Belem',
        label: 'America/Belem (GMT-3)',
        hint: 'Белен, Бразилия'
    },
    {
        value: 'America/Belize',
        label: 'America/Belize (GMT-6)',
        hint: 'Белиз, Белиз'
    },
    {
        value: 'America/Blanc-Sablon',
        label: 'America/Blanc-Sablon (GMT-4)',
        hint: 'Бланк-Саблон, Канада'
    },
    {
        value: 'America/Boa_Vista',
        label: 'America/Boa_Vista (GMT-4)',
        hint: 'Боа-Виста, Бразилия'
    },
    {
        value: 'America/Bogota',
        label: 'America/Bogota (GMT-5)',
        hint: 'Богота, Колумбия'
    },
    {
        value: 'America/Boise',
        label: 'America/Boise (GMT-6)',
        hint: 'Бойсе, Соединенные Штаты'
    },
    {
        value: 'America/Buenos_Aires',
        label: 'America/Buenos_Aires (GMT-3)',
        hint: 'Буэнос-Айрес, Аргентина'
    },
    {
        value: 'America/Cambridge_Bay',
        label: 'America/Cambridge_Bay (GMT-6)',
        hint: 'Кеймбридж-Бей, Канада'
    },
    {
        value: 'America/Campo_Grande',
        label: 'America/Campo_Grande (GMT-4)',
        hint: 'Кампу-Гранди, Бразилия'
    },
    {
        value: 'America/Cancun',
        label: 'America/Cancun (GMT-5)',
        hint: 'Канкун, Мексика'
    },
    {
        value: 'America/Caracas',
        label: 'America/Caracas (GMT-4)',
        hint: 'Каракас, Венесуэла'
    },
    {
        value: 'America/Catamarca',
        label: 'America/Catamarca (GMT-3)',
        hint: 'Катамарка, Аргентина'
    },
    {
        value: 'America/Cayenne',
        label: 'America/Cayenne (GMT-3)',
        hint: 'Кайенна, Французская Гвиана'
    },
    {
        value: 'America/Cayman',
        label: 'America/Cayman (GMT-5)',
        hint: 'о-ва Кайман'
    },
    {
        value: 'America/Chicago',
        label: 'America/Chicago (GMT-5)',
        hint: 'Чикаго, Соединенные Штаты'
    },
    {
        value: 'America/Chihuahua',
        label: 'America/Chihuahua (GMT-6)',
        hint: 'Чиуауа, Мексика'
    },
    {
        value: 'America/Ciudad_Juarez',
        label: 'America/Ciudad_Juarez (GMT-6)',
        hint: 'Сьюдад-Хуарес, Мексика'
    },
    {
        value: 'America/Coral_Harbour',
        label: 'America/Coral_Harbour (GMT-5)',
        hint: 'Корал-Харбор, Канада'
    },
    {
        value: 'America/Cordoba',
        label: 'America/Cordoba (GMT-3)',
        hint: 'Кордова, Аргентина'
    },
    {
        value: 'America/Costa_Rica',
        label: 'America/Costa_Rica (GMT-6)',
        hint: 'Коста-Рика, Коста-Рика'
    },
    {
        value: 'America/Coyhaique',
        label: 'America/Coyhaique (GMT-3)',
        hint: 'Койайке, Чили'
    },
    {
        value: 'America/Creston',
        label: 'America/Creston (GMT-7)',
        hint: 'Крестон, Канада'
    },
    {
        value: 'America/Cuiaba',
        label: 'America/Cuiaba (GMT-4)',
        hint: 'Куяба, Бразилия'
    },
    {
        value: 'America/Curacao',
        label: 'America/Curacao (GMT-4)',
        hint: 'Кюрасао'
    },
    {
        value: 'America/Danmarkshavn',
        label: 'America/Danmarkshavn (GMT+0)',
        hint: 'Денмарксхавн, Гренландия'
    },
    {
        value: 'America/Dawson',
        label: 'America/Dawson (GMT-7)',
        hint: 'Доусон, Канада'
    },
    {
        value: 'America/Dawson_Creek',
        label: 'America/Dawson_Creek (GMT-7)',
        hint: 'Доусон-Крик, Канада'
    },
    {
        value: 'America/Denver',
        label: 'America/Denver (GMT-6)',
        hint: 'Денвер, Соединенные Штаты'
    },
    {
        value: 'America/Detroit',
        label: 'America/Detroit (GMT-4)',
        hint: 'Детройт, Соединенные Штаты'
    },
    {
        value: 'America/Dominica',
        label: 'America/Dominica (GMT-4)',
        hint: 'Доминика'
    },
    {
        value: 'America/Edmonton',
        label: 'America/Edmonton (GMT-6)',
        hint: 'Эдмонтон, Канада'
    },
    {
        value: 'America/Eirunepe',
        label: 'America/Eirunepe (GMT-5)',
        hint: 'Эйрунепе, Бразилия'
    },
    {
        value: 'America/El_Salvador',
        label: 'America/El_Salvador (GMT-6)',
        hint: 'Сальвадор'
    },
    {
        value: 'America/Fort_Nelson',
        label: 'America/Fort_Nelson (GMT-7)',
        hint: 'Форт Нельсон, Канада'
    },
    {
        value: 'America/Fortaleza',
        label: 'America/Fortaleza (GMT-3)',
        hint: 'Форталеза, Бразилия'
    },
    {
        value: 'America/Glace_Bay',
        label: 'America/Glace_Bay (GMT-3)',
        hint: 'Глейс-Бей, Канада'
    },
    {
        value: 'America/Godthab',
        label: 'America/Godthab (GMT-1)',
        hint: 'Нуук, Гренландия'
    },
    {
        value: 'America/Goose_Bay',
        label: 'America/Goose_Bay (GMT-3)',
        hint: 'Гус-Бей, Канада'
    },
    {
        value: 'America/Grand_Turk',
        label: 'America/Grand_Turk (GMT-4)',
        hint: 'Тёркс и Кайкос'
    },
    {
        value: 'America/Grenada',
        label: 'America/Grenada (GMT-4)',
        hint: 'Гренада'
    },
    {
        value: 'America/Guadeloupe',
        label: 'America/Guadeloupe (GMT-4)',
        hint: 'Гваделупа'
    },
    {
        value: 'America/Guatemala',
        label: 'America/Guatemala (GMT-6)',
        hint: 'Гватемала'
    },
    {
        value: 'America/Guayaquil',
        label: 'America/Guayaquil (GMT-5)',
        hint: 'Гуаякиль, Эквадор'
    },
    {
        value: 'America/Guyana',
        label: 'America/Guyana (GMT-4)',
        hint: 'Гайана'
    },
    {
        value: 'America/Halifax',
        label: 'America/Halifax (GMT-3)',
        hint: 'Галифакс, Канада'
    },
    {
        value: 'America/Havana',
        label: 'America/Havana (GMT-4)',
        hint: 'Гавана, Куба'
    },
    {
        value: 'America/Hermosillo',
        label: 'America/Hermosillo (GMT-7)',
        hint: 'Эрмосильо, Мексика'
    },
    {
        value: 'America/Indiana/Knox',
        label: 'America/Indiana/Knox (GMT-5)',
        hint: 'Knox, Соединенные Штаты (Нокс'
    },
    {
        value: 'America/Indiana/Marengo',
        label: 'America/Indiana/Marengo (GMT-4)',
        hint: 'Маренго, Соединенные Штаты'
    },
    {
        value: 'America/Indiana/Petersburg',
        label: 'America/Indiana/Petersburg (GMT-4)',
        hint: 'Питерсберг, Соединенные Штаты'
    },
    {
        value: 'America/Indiana/Tell_City',
        label: 'America/Indiana/Tell_City (GMT-5)',
        hint: 'Телл-Сити, Соединенные Штаты'
    },
    {
        value: 'America/Indiana/Vevay',
        label: 'America/Indiana/Vevay (GMT-4)',
        hint: 'Вевей, Соединенные Штаты'
    },
    {
        value: 'America/Indiana/Vincennes',
        label: 'America/Indiana/Vincennes (GMT-4)',
        hint: 'Винсеннес, Соединенные Штаты'
    },
    {
        value: 'America/Indiana/Winamac',
        label: 'America/Indiana/Winamac (GMT-4)',
        hint: 'Уинамак, Соединенные Штаты'
    },
    {
        value: 'America/Indianapolis',
        label: 'America/Indianapolis (GMT-4)',
        hint: 'Индианаполис, Соединенные Штаты'
    },
    {
        value: 'America/Inuvik',
        label: 'America/Inuvik (GMT-6)',
        hint: 'Инувик, Канада'
    },
    {
        value: 'America/Iqaluit',
        label: 'America/Iqaluit (GMT-4)',
        hint: 'Икалуит, Канада'
    },
    {
        value: 'America/Jamaica',
        label: 'America/Jamaica (GMT-5)',
        hint: 'Ямайка'
    },
    {
        value: 'America/Jujuy',
        label: 'America/Jujuy (GMT-3)',
        hint: 'Жужуй, Аргентина'
    },
    {
        value: 'America/Juneau',
        label: 'America/Juneau (GMT-8)',
        hint: 'Джуно, Соединенные Штаты'
    },
    {
        value: 'America/Kentucky/Monticello',
        label: 'America/Kentucky/Monticello (GMT-4)',
        hint: 'Монтиселло, Соединенные Штаты'
    },
    {
        value: 'America/Kralendijk',
        label: 'America/Kralendijk (GMT-4)',
        hint: 'Кралендейк, Бонэйр'
    },
    {
        value: 'America/La_Paz',
        label: 'America/La_Paz (GMT-4)',
        hint: 'Ла-Пас, Боливия'
    },
    {
        value: 'America/Lima',
        label: 'America/Lima (GMT-5)',
        hint: 'Лима, Перу'
    },
    {
        value: 'America/Los_Angeles',
        label: 'America/Los_Angeles (GMT-7)',
        hint: 'Лос-Анджелес, Соединенные Штаты'
    },
    {
        value: 'America/Louisville',
        label: 'America/Louisville (GMT-4)',
        hint: 'Луисвилл, Соединенные Штаты'
    },
    {
        value: 'America/Maceio',
        label: 'America/Maceio (GMT-3)',
        hint: 'Масейо, Бразилия'
    },
    {
        value: 'America/Manaus',
        label: 'America/Manaus (GMT-4)',
        hint: 'Манаус, Бразилия'
    },
    {
        value: 'America/Matamoros',
        label: 'America/Matamoros (GMT-5)',
        hint: 'Матаморос, Мексика'
    },
    {
        value: 'America/Mazatlan',
        label: 'America/Mazatlan (GMT-7)',
        hint: 'Масатлан, Мексика'
    },
    {
        value: 'America/Mendoza',
        label: 'America/Mendoza (GMT-3)',
        hint: 'Мендоса, Аргентина'
    },
    {
        value: 'America/Menominee',
        label: 'America/Menominee (GMT-5)',
        hint: 'Меномини, Соединенные Штаты'
    },
    {
        value: 'America/Merida',
        label: 'America/Merida (GMT-6)',
        hint: 'Мерида, Мексика'
    },
    {
        value: 'America/Metlakatla',
        label: 'America/Metlakatla (GMT-8)',
        hint: 'Метлакатла, Соединенные Штаты'
    },
    {
        value: 'America/Mexico_City',
        label: 'America/Mexico_City (GMT-6)',
        hint: 'Мехико, Мексика'
    },
    {
        value: 'America/Moncton',
        label: 'America/Moncton (GMT-3)',
        hint: 'Монктон, Канада'
    },
    {
        value: 'America/Monterrey',
        label: 'America/Monterrey (GMT-6)',
        hint: 'Монтеррей, Мексика'
    },
    {
        value: 'America/Montevideo',
        label: 'America/Montevideo (GMT-3)',
        hint: 'Монтевидео, Уругвай'
    },
    {
        value: 'America/Montserrat',
        label: 'America/Montserrat (GMT-4)',
        hint: 'Монтсеррат, Монтсеррат'
    },
    {
        value: 'America/Nassau',
        label: 'America/Nassau (GMT-4)',
        hint: 'Нассау, Багамы'
    },
    {
        value: 'America/New_York',
        label: 'America/New_York (GMT-4)',
        hint: 'Нью-Йорк, Соединенные Штаты'
    },
    {
        value: 'America/Nome',
        label: 'America/Nome (GMT-8)',
        hint: 'Ном, Соединенные Штаты'
    },
    {
        value: 'America/Noronha',
        label: 'America/Noronha (GMT-2)',
        hint: 'Норонья, Бразилия'
    },
    {
        value: 'America/Ojinaga',
        label: 'America/Ojinaga (GMT-5)',
        hint: 'Охинага, Мексика'
    },
    {
        value: 'America/Panama',
        label: 'America/Panama (GMT-5)',
        hint: 'Панама, Панама'
    },
    {
        value: 'America/Phoenix',
        label: 'America/Phoenix (GMT-7)',
        hint: 'Финикс, Соединенные Штаты'
    },
    {
        value: 'America/Porto_Velho',
        label: 'America/Porto_Velho (GMT-4)',
        hint: 'Порту-Велью, Бразилия'
    },
    {
        value: 'America/Puerto_Rico',
        label: 'America/Puerto_Rico (GMT-4)',
        hint: 'Пуэрто-Рико, Пуэрто-Рико'
    },
    {
        value: 'America/Punta_Arenas',
        label: 'America/Punta_Arenas (GMT-3)',
        hint: 'Пунта-Аренас, Чили'
    },
    {
        value: 'America/Rankin_Inlet',
        label: 'America/Rankin_Inlet (GMT-5)',
        hint: 'Ранкин-Инлет, Канада'
    },
    {
        value: 'America/Recife',
        label: 'America/Recife (GMT-3)',
        hint: 'Ресифи, Бразилия'
    },
    {
        value: 'America/Regina',
        label: 'America/Regina (GMT-6)',
        hint: 'Реджайна, Канада'
    },
    {
        value: 'America/Resolute',
        label: 'America/Resolute (GMT-5)',
        hint: 'Резольют, Канада'
    },
    {
        value: 'America/Rio_Branco',
        label: 'America/Rio_Branco (GMT-5)',
        hint: 'Риу-Бранку, Бразилия'
    },
    {
        value: 'America/Santarem',
        label: 'America/Santarem (GMT-3)',
        hint: 'Сантарен, Бразилия'
    },
    {
        value: 'America/Santiago',
        label: 'America/Santiago (GMT-4)',
        hint: 'Сантьяго, Чили'
    },
    {
        value: 'America/Sao_Paulo',
        label: 'America/Sao_Paulo (GMT-3)',
        hint: 'Сан-Паулу, Бразилия'
    },
    {
        value: 'America/Scoresbysund',
        label: 'America/Scoresbysund (GMT-1)',
        hint: 'Скорсбисунн, Гренландия'
    },
    {
        value: 'America/Sitka',
        label: 'America/Sitka (GMT-8)',
        hint: 'Ситка, Соединенные Штаты'
    },
    {
        value: 'America/St_Johns',
        label: 'America/St_Johns (GMT-2)',
        hint: 'Сент-Джонс, Канада'
    },
    {
        value: 'America/St_Thomas',
        label: 'America/St_Thomas (GMT-4)',
        hint: 'США, Виргинские о-ва'
    },
    {
        value: 'America/Swift_Current',
        label: 'America/Swift_Current (GMT-6)',
        hint: 'Свифт-Керрент, Канада'
    },
    {
        value: 'America/Thule',
        label: 'America/Thule (GMT-3)',
        hint: 'Туле, Гренландия'
    },
    {
        value: 'America/Tijuana',
        label: 'America/Tijuana (GMT-7)',
        hint: 'Тихуана, Мексика'
    },
    {
        value: 'America/Toronto',
        label: 'America/Toronto (GMT-4)',
        hint: 'Торонто, Канада'
    },
    {
        value: 'America/Tortola',
        label: 'America/Tortola (GMT-4)',
        hint: 'Великобритания, Виргинские о-ва'
    },
    {
        value: 'America/Vancouver',
        label: 'America/Vancouver (GMT-7)',
        hint: 'Ванкувер, Канада'
    },
    {
        value: 'America/Whitehorse',
        label: 'America/Whitehorse (GMT-7)',
        hint: 'Уайтхорс, Канада'
    },
    {
        value: 'America/Winnipeg',
        label: 'America/Winnipeg (GMT-5)',
        hint: 'Виннипег, Канада'
    },
    {
        value: 'America/Yakutat',
        label: 'America/Yakutat (GMT-8)',
        hint: 'Якутат, Соединенные Штаты'
    },
    {
        value: 'Antarctica/Casey',
        label: 'Antarctica/Casey (GMT+8)',
        hint: 'Кейси, Антарктида'
    },
    {
        value: 'Antarctica/Davis',
        label: 'Antarctica/Davis (GMT+7)',
        hint: 'Дейвис, Антарктида'
    },
    {
        value: 'Antarctica/DumontDUrville',
        label: 'Antarctica/DumontDUrville (GMT+10)',
        hint: 'Дюмон-д’Юрвиль, Антарктида'
    },
    {
        value: 'Antarctica/Macquarie',
        label: 'Antarctica/Macquarie (GMT+10)',
        hint: 'Маккуори, Австралия'
    },
    {
        value: 'Antarctica/Mawson',
        label: 'Antarctica/Mawson (GMT+5)',
        hint: 'Моусон, Антарктида'
    },
    {
        value: 'Antarctica/McMurdo',
        label: 'Antarctica/McMurdo (GMT+12)',
        hint: 'Мак-Мердо, Антарктида'
    },
    {
        value: 'Antarctica/Palmer',
        label: 'Antarctica/Palmer (GMT-3)',
        hint: 'Палмер, Антарктида'
    },
    {
        value: 'Antarctica/Rothera',
        label: 'Antarctica/Rothera (GMT-3)',
        hint: 'Ротера, Антарктида'
    },
    {
        value: 'Antarctica/Syowa',
        label: 'Antarctica/Syowa (GMT+3)',
        hint: 'Сёва, Антарктида'
    },
    {
        value: 'Antarctica/Troll',
        label: 'Antarctica/Troll (GMT+2)',
        hint: 'Тролль, весь мир'
    },
    {
        value: 'Antarctica/Vostok',
        label: 'Antarctica/Vostok (GMT+5)',
        hint: 'Восток, Антарктида'
    },
    {
        value: 'Asia/Almaty',
        label: 'Asia/Almaty (GMT+5)',
        hint: 'Алматы, Казахстан'
    },
    {
        value: 'Asia/Amman',
        label: 'Asia/Amman (GMT+3)',
        hint: 'Amman, Иордания'
    },
    {
        value: 'Asia/Anadyr',
        label: 'Asia/Anadyr (GMT+12)',
        hint: 'Анадырь, Россия'
    },
    {
        value: 'Asia/Aqtau',
        label: 'Asia/Aqtau (GMT+5)',
        hint: 'Актау, Казахстан'
    },
    {
        value: 'Asia/Aqtobe',
        label: 'Asia/Aqtobe (GMT+5)',
        hint: 'Актобе, Казахстан'
    },
    {
        value: 'Asia/Atyrau',
        label: 'Asia/Atyrau (GMT+5)',
        hint: 'Атырау, Казахстан'
    },
    {
        value: 'Asia/Barnaul',
        label: 'Asia/Barnaul (GMT+7)',
        hint: 'Барнаул, Россия'
    },
    {
        value: 'Asia/Chita',
        label: 'Asia/Chita (GMT+9)',
        hint: 'Чита, Россия'
    },
    {
        value: 'Asia/Famagusta',
        label: 'Asia/Famagusta (GMT+3)',
        hint: 'Фамагуста, Кипр'
    },
    {
        value: 'Asia/Gaza',
        label: 'Asia/Gaza (GMT+3)',
        hint: 'Газа, Палестинские территории'
    },
    {
        value: 'Asia/Hebron',
        label: 'Asia/Hebron (GMT+3)',
        hint: 'Хеврон, Палестинские территории'
    },
    {
        value: 'Asia/Hong_Kong',
        label: 'Asia/Hong_Kong (GMT+8)',
        hint: 'САР, Гонконг'
    },
    {
        value: 'Asia/Hovd',
        label: 'Asia/Hovd (GMT+7)',
        hint: 'Ховд, Монголия'
    },
    {
        value: 'Asia/Irkutsk',
        label: 'Asia/Irkutsk (GMT+8)',
        hint: 'Иркутск, Россия'
    },
    {
        value: 'Asia/Jakarta',
        label: 'Asia/Jakarta (GMT+7)',
        hint: 'Джакарта, Индонезия'
    },
    {
        value: 'Asia/Jayapura',
        label: 'Asia/Jayapura (GMT+9)',
        hint: 'Джаяпура, Индонезия'
    },
    {
        value: 'Asia/Jerusalem',
        label: 'Asia/Jerusalem (GMT+3)',
        hint: 'Иерусалим, Израиль'
    },
    {
        value: 'Asia/Kabul',
        label: 'Asia/Kabul (GMT+4)',
        hint: 'Кабул, Афганистан'
    },
    {
        value: 'Asia/Kamchatka',
        label: 'Asia/Kamchatka (GMT+12)',
        hint: 'Петропавловск-Камчатский, Россия'
    },
    {
        value: 'Asia/Katmandu',
        label: 'Asia/Katmandu (GMT+5)',
        hint: 'Катманду, Непал'
    },
    {
        value: 'Asia/Khandyga',
        label: 'Asia/Khandyga (GMT+9)',
        hint: 'Хандыга, Россия'
    },
    {
        value: 'Asia/Krasnoyarsk',
        label: 'Asia/Krasnoyarsk (GMT+7)',
        hint: 'Красноярск, Россия'
    },
    {
        value: 'Asia/Kuala_Lumpur',
        label: 'Asia/Kuala_Lumpur (GMT+8)',
        hint: 'Куала-Лумпур, Малайзия'
    },
    {
        value: 'Asia/Kuching',
        label: 'Asia/Kuching (GMT+8)',
        hint: 'Кучинг, Малайзия'
    },
    {
        value: 'Asia/Kuwait',
        label: 'Asia/Kuwait (GMT+3)',
        hint: 'Кувейт, Кувейт'
    },
    {
        value: 'Asia/Macau',
        label: 'Asia/Macau (GMT+8)',
        hint: 'САР, Макао'
    },
    {
        value: 'Asia/Magadan',
        label: 'Asia/Magadan (GMT+11)',
        hint: 'Магадан, Россия'
    },
    {
        value: 'Asia/Makassar',
        label: 'Asia/Makassar (GMT+8)',
        hint: 'Макасар, Индонезия'
    },
    {
        value: 'Asia/Manila',
        label: 'Asia/Manila (GMT+8)',
        hint: 'Манила, Филиппины'
    },
    {
        value: 'Asia/Nicosia',
        label: 'Asia/Nicosia (GMT+3)',
        hint: 'Никосия, Кипр'
    },
    {
        value: 'Asia/Novokuznetsk',
        label: 'Asia/Novokuznetsk (GMT+7)',
        hint: 'Новокузнецк, Россия'
    },
    {
        value: 'Asia/Novosibirsk',
        label: 'Asia/Novosibirsk (GMT+7)',
        hint: 'Новосибирск, Россия'
    },
    {
        value: 'Asia/Omsk',
        label: 'Asia/Omsk (GMT+6)',
        hint: 'Омск, Россия'
    },
    {
        value: 'Asia/Oral',
        label: 'Asia/Oral (GMT+5)',
        hint: 'Уральск, Казахстан'
    },
    {
        value: 'Asia/Pontianak',
        label: 'Asia/Pontianak (GMT+7)',
        hint: 'Понтианак, Индонезия'
    },
    {
        value: 'Asia/Pyongyang',
        label: 'Asia/Pyongyang (GMT+9)',
        hint: 'Пхеньян, КНДР'
    },
    {
        value: 'Asia/Qatar',
        label: 'Asia/Qatar (GMT+3)',
        hint: 'Катар, Катар'
    },
    {
        value: 'Asia/Qostanay',
        label: 'Asia/Qostanay (GMT+5)',
        hint: 'Костанай, Казахстан'
    },
    {
        value: 'Asia/Qyzylorda',
        label: 'Asia/Qyzylorda (GMT+5)',
        hint: 'Кызылорда, Казахстан'
    },
    {
        value: 'Asia/Rangoon',
        label: 'Asia/Rangoon (GMT+6)',
        hint: 'Бирма, Мьянма'
    },
    {
        value: 'Asia/Riyadh',
        label: 'Asia/Riyadh (GMT+3)',
        hint: 'Эр-Рияд, Саудовская Аравия'
    },
    {
        value: 'Asia/Saigon',
        label: 'Asia/Saigon (GMT+7)',
        hint: 'Хошимин, Вьетнам'
    },
    {
        value: 'Asia/Sakhalin',
        label: 'Asia/Sakhalin (GMT+11)',
        hint: 'о-в Сахалин, Россия'
    },
    {
        value: 'Asia/Samarkand',
        label: 'Asia/Samarkand (GMT+5)',
        hint: 'Самарканд, Узбекистан'
    },
    {
        value: 'Asia/Seoul',
        label: 'Asia/Seoul (GMT+9)',
        hint: 'Сеул, Республика Корея'
    },
    {
        value: 'Asia/Shanghai',
        label: 'Asia/Shanghai (GMT+8)',
        hint: 'Шанхай, Китай'
    },
    {
        value: 'Asia/Singapore',
        label: 'Asia/Singapore (GMT+8)',
        hint: 'Сингапур, Сингапур'
    },
    {
        value: 'Asia/Srednekolymsk',
        label: 'Asia/Srednekolymsk (GMT+11)',
        hint: 'Среднеколымск, Россия'
    },
    {
        value: 'Asia/Taipei',
        label: 'Asia/Taipei (GMT+8)',
        hint: 'Тайбэй, Тайвань'
    },
    {
        value: 'Asia/Tashkent',
        label: 'Asia/Tashkent (GMT+5)',
        hint: 'Ташкент, Узбекистан'
    },
    {
        value: 'Asia/Tbilisi',
        label: 'Asia/Tbilisi (GMT+4)',
        hint: 'Тбилиси, Грузия'
    },
    {
        value: 'Asia/Tehran',
        label: 'Asia/Tehran (GMT+3)',
        hint: 'Тегеран, Иран'
    },
    {
        value: 'Asia/Tokyo',
        label: 'Asia/Tokyo (GMT+9)',
        hint: 'Токио, Япония'
    },
    {
        value: 'Asia/Tomsk',
        label: 'Asia/Tomsk (GMT+7)',
        hint: 'Томск, Россия'
    },
    {
        value: 'Asia/Ulaanbaatar',
        label: 'Asia/Ulaanbaatar (GMT+8)',
        hint: 'Улан-Батор, Монголия'
    },
    {
        value: 'Asia/Urumqi',
        label: 'Asia/Urumqi (GMT+6)',
        hint: 'Урумчи, Китай'
    },
    {
        value: 'Asia/Ust-Nera',
        label: 'Asia/Ust-Nera (GMT+10)',
        hint: 'Усть-Нера, Россия'
    },
    {
        value: 'Asia/Vladivostok',
        label: 'Asia/Vladivostok (GMT+10)',
        hint: 'Владивосток, Россия'
    },
    {
        value: 'Asia/Yakutsk',
        label: 'Asia/Yakutsk (GMT+9)',
        hint: 'Якутск, Россия'
    },
    {
        value: 'Asia/Yekaterinburg',
        label: 'Asia/Yekaterinburg (GMT+5)',
        hint: 'Екатеринбург, Россия'
    },
    {
        value: 'Asia/Yerevan',
        label: 'Asia/Yerevan (GMT+4)',
        hint: 'Ереван, Армения'
    },
    {
        value: 'Atlantic/Azores',
        label: 'Atlantic/Azores (GMT+0)',
        hint: 'Азорские о-ва, Португалия'
    },
    {
        value: 'Atlantic/Canary',
        label: 'Atlantic/Canary (GMT+1)',
        hint: 'Канарские о-ва, Испания'
    },
    {
        value: 'Atlantic/Madeira',
        label: 'Atlantic/Madeira (GMT+1)',
        hint: 'Мадейра, Португалия'
    },
    {
        value: 'Atlantic/Reykjavik',
        label: 'Atlantic/Reykjavik (GMT+0)',
        hint: 'Рейкьявик, Исландия'
    },
    {
        value: 'Australia/Adelaide',
        label: 'Australia/Adelaide (GMT+9)',
        hint: 'Аделаида, Австралия'
    },
    {
        value: 'Australia/Brisbane',
        label: 'Australia/Brisbane (GMT+10)',
        hint: 'Брисбен, Австралия'
    },
    {
        value: 'Australia/Broken_Hill',
        label: 'Australia/Broken_Hill (GMT+9)',
        hint: 'Брокен-Хилл, Австралия'
    },
    {
        value: 'Australia/Darwin',
        label: 'Australia/Darwin (GMT+9)',
        hint: 'Дарвин, Австралия'
    },
    {
        value: 'Australia/Eucla',
        label: 'Australia/Eucla (GMT+8)',
        hint: 'Юкла, Австралия'
    },
    {
        value: 'Australia/Hobart',
        label: 'Australia/Hobart (GMT+10)',
        hint: 'Хобарт, Австралия'
    },
    {
        value: 'Australia/Lindeman',
        label: 'Australia/Lindeman (GMT+10)',
        hint: 'Линдеман, Австралия'
    },
    {
        value: 'Australia/Lord_Howe',
        label: 'Australia/Lord_Howe (GMT+10)',
        hint: 'Лорд-Хау, Австралия'
    },
    {
        value: 'Australia/Melbourne',
        label: 'Australia/Melbourne (GMT+10)',
        hint: 'Мельбурн, Австралия'
    },
    {
        value: 'Australia/Perth',
        label: 'Australia/Perth (GMT+8)',
        hint: 'Перт, Австралия'
    },
    {
        value: 'Australia/Sydney',
        label: 'Australia/Sydney (GMT+10)',
        hint: 'Сидней, Австралия'
    },
    {
        value: 'Europe/Amsterdam',
        label: 'Europe/Amsterdam (GMT+2)',
        hint: 'Амстердам, Нидерланды'
    },
    {
        value: 'Europe/Andorra',
        label: 'Europe/Andorra (GMT+2)',
        hint: 'Андорра, Андорра'
    },
    {
        value: 'Europe/Astrakhan',
        label: 'Europe/Astrakhan (GMT+4)',
        hint: 'Астрахань, Россия'
    },
    {
        value: 'Europe/Athens',
        label: 'Europe/Athens (GMT+3)',
        hint: 'Афины, Греция'
    },
    {
        value: 'Europe/Belgrade',
        label: 'Europe/Belgrade (GMT+2)',
        hint: 'Белград, Сербия'
    },
    {
        value: 'Europe/Berlin',
        label: 'Europe/Berlin (GMT+2)',
        hint: 'Берлин, Германия'
    },
    {
        value: 'Europe/Bratislava',
        label: 'Europe/Bratislava (GMT+2)',
        hint: 'Братислава, Словакия'
    },
    {
        value: 'Europe/Brussels',
        label: 'Europe/Brussels (GMT+2)',
        hint: 'Брюссель, Бельгия'
    },
    {
        value: 'Europe/Bucharest',
        label: 'Europe/Bucharest (GMT+3)',
        hint: 'Бухарест, Румыния'
    },
    {
        value: 'Europe/Budapest',
        label: 'Europe/Budapest (GMT+2)',
        hint: 'Будапешт, Венгрия'
    },
    {
        value: 'Europe/Busingen',
        label: 'Europe/Busingen (GMT+2)',
        hint: 'Бюзинген-на-Верхнем-Рейне, Германия'
    },
    {
        value: 'Europe/Chisinau',
        label: 'Europe/Chisinau (GMT+3)',
        hint: 'Кишинёв, Молдова'
    },
    {
        value: 'Europe/Copenhagen',
        label: 'Europe/Copenhagen (GMT+2)',
        hint: 'Копенгаген, Дания'
    },
    {
        value: 'Europe/Dublin',
        label: 'Europe/Dublin (GMT+1)',
        hint: 'Дублин, Ирландия'
    },
    {
        value: 'Europe/Gibraltar',
        label: 'Europe/Gibraltar (GMT+2)',
        hint: 'Гибралтар, Гибралтар'
    },
    {
        value: 'Europe/Guernsey',
        label: 'Europe/Guernsey (GMT+1)',
        hint: 'Гернси, Гернси'
    },
    {
        value: 'Europe/Helsinki',
        label: 'Europe/Helsinki (GMT+3)',
        hint: 'Хельсинки, Финляндия'
    },
    {
        value: 'Europe/Istanbul',
        label: 'Europe/Istanbul (GMT+3)',
        hint: 'Стамбул, Турция'
    },
    {
        value: 'Europe/Kaliningrad',
        label: 'Europe/Kaliningrad (GMT+2)',
        hint: 'Калининград, Россия'
    },
    {
        value: 'Europe/Kiev',
        label: 'Europe/Kiev (GMT+3)',
        hint: 'Киев, Украина'
    },
    {
        value: 'Europe/Kirov',
        label: 'Europe/Kirov (GMT+3)',
        hint: 'Киров, Россия'
    },
    {
        value: 'Europe/Lisbon',
        label: 'Europe/Lisbon (GMT+1)',
        hint: 'Лиссабон, Португалия'
    },
    {
        value: 'Europe/Ljubljana',
        label: 'Europe/Ljubljana (GMT+2)',
        hint: 'Любляна, Словения'
    },
    {
        value: 'Europe/London',
        label: 'Europe/London (GMT+1)',
        hint: 'Лондон, Великобритания'
    },
    {
        value: 'Europe/Luxembourg',
        label: 'Europe/Luxembourg (GMT+2)',
        hint: 'Люксембург, Люксембург'
    },
    {
        value: 'Europe/Madrid',
        label: 'Europe/Madrid (GMT+2)',
        hint: 'Мадрид, Испания'
    },
    {
        value: 'Europe/Malta',
        label: 'Europe/Malta (GMT+2)',
        hint: 'Мальта, Мальта'
    },
    {
        value: 'Europe/Minsk',
        label: 'Europe/Minsk (GMT+3)',
        hint: 'Минск, Беларусь'
    },
    {
        value: 'Europe/Monaco',
        label: 'Europe/Monaco (GMT+2)',
        hint: 'Монако, Монако'
    },
    {
        value: 'Europe/Moscow',
        label: 'Europe/Moscow (GMT+3)',
        hint: 'Москва, Россия'
    },
    {
        value: 'Europe/Oslo',
        label: 'Europe/Oslo (GMT+2)',
        hint: 'Осло, Норвегия'
    },
    {
        value: 'Europe/Paris',
        label: 'Europe/Paris (GMT+2)',
        hint: 'Париж, Франция'
    },
    {
        value: 'Europe/Podgorica',
        label: 'Europe/Podgorica (GMT+2)',
        hint: 'Подгорица, Черногория'
    },
    {
        value: 'Europe/Prague',
        label: 'Europe/Prague (GMT+2)',
        hint: 'Прага, Чехия'
    },
    {
        value: 'Europe/Riga',
        label: 'Europe/Riga (GMT+3)',
        hint: 'Рига, Латвия'
    },
    {
        value: 'Europe/Rome',
        label: 'Europe/Rome (GMT+2)',
        hint: 'Рим, Италия'
    },
    {
        value: 'Europe/Samara',
        label: 'Europe/Samara (GMT+4)',
        hint: 'Самара, Россия'
    },
    {
        value: 'Europe/San_Marino',
        label: 'Europe/San_Marino (GMT+2)',
        hint: 'Сан-Марино, Сан-Марино'
    },
    {
        value: 'Europe/Sarajevo',
        label: 'Europe/Sarajevo (GMT+2)',
        hint: 'Сараево, Босния и Герцеговина'
    },
    {
        value: 'Europe/Saratov',
        label: 'Europe/Saratov (GMT+4)',
        hint: 'Саратов, Россия'
    },
    {
        value: 'Europe/Simferopol',
        label: 'Europe/Simferopol (GMT+3)',
        hint: 'Симферополь, Россия'
    },
    {
        value: 'Europe/Skopje',
        label: 'Europe/Skopje (GMT+2)',
        hint: 'Скопье, Северная Македония'
    },
    {
        value: 'Europe/Sofia',
        label: 'Europe/Sofia (GMT+3)',
        hint: 'София, Болгария'
    },
    {
        value: 'Europe/Stockholm',
        label: 'Europe/Stockholm (GMT+2)',
        hint: 'Стокгольм, Швеция'
    },
    {
        value: 'Europe/Tallinn',
        label: 'Europe/Tallinn (GMT+3)',
        hint: 'Таллин, Эстония'
    },
    {
        value: 'Europe/Tirane',
        label: 'Europe/Tirane (GMT+2)',
        hint: 'Тирана, Албания'
    },
    {
        value: 'Europe/Ulyanovsk',
        label: 'Europe/Ulyanovsk (GMT+4)',
        hint: 'Ульяновск, Россия'
    },
    {
        value: 'Europe/Vatican',
        label: 'Europe/Vatican (GMT+2)',
        hint: 'Ватикан, Ватикан'
    },
    {
        value: 'Europe/Vienna',
        label: 'Europe/Vienna (GMT+2)',
        hint: 'Виенна, Австрия'
    },
    {
        value: 'Europe/Vilnius',
        label: 'Europe/Vilnius (GMT+3)',
        hint: 'Вильнюс, Литва'
    },
    {
        value: 'Europe/Volgograd',
        label: 'Europe/Volgograd (GMT+3)',
        hint: 'Волгоград, Россия'
    },
    {
        value: 'Europe/Warsaw',
        label: 'Europe/Warsaw (GMT+2)',
        hint: 'Варшава, Польша'
    },
    {
        value: 'Europe/Zagreb',
        label: 'Europe/Zagreb (GMT+2)',
        hint: 'Загреб, Хорватия'
    },
    {
        value: 'Europe/Zurich',
        label: 'Europe/Zurich (GMT+2)',
        hint: 'Цюрих, Швейцария'
    },
    {
        value: 'Indian/Antananarivo',
        label: 'Indian/Antananarivo (GMT+3)',
        hint: 'Антананариву, Мадагаскар'
    },
    {
        value: 'Pacific/Apia',
        label: 'Pacific/Apia (GMT+13)',
        hint: 'Апиа, Самоа'
    },
    {
        value: 'Pacific/Auckland',
        label: 'Pacific/Auckland (GMT+12)',
        hint: 'Окленд, Новая Зеландия'
    },
    {
        value: 'Pacific/Bougainville',
        label: 'Pacific/Bougainville (GMT+11)',
        hint: 'Бугенвиль, Папуа — Новая Гвинея'
    },
    {
        value: 'Pacific/Chatham',
        label: 'Pacific/Chatham (GMT+12)',
        hint: 'Чатем, Новая Зеландия'
    },
    {
        value: 'Pacific/Easter',
        label: 'Pacific/Easter (GMT-6)',
        hint: 'о-в Пасхи, Чили'
    },
    {
        value: 'Pacific/Efate',
        label: 'Pacific/Efate (GMT+11)',
        hint: 'Эфате, Вануату'
    },
    {
        value: 'Pacific/Enderbury',
        label: 'Pacific/Enderbury (GMT+13)',
        hint: 'о-в Эндербери, Кирибати'
    },
    {
        value: 'Pacific/Fakaofo',
        label: 'Pacific/Fakaofo (GMT+13)',
        hint: 'Факаофо, Токелау'
    },
    {
        value: 'Pacific/Fiji',
        label: 'Pacific/Fiji (GMT+12)',
        hint: 'Фиджи, Фиджи'
    },
    {
        value: 'Pacific/Funafuti',
        label: 'Pacific/Funafuti (GMT+12)',
        hint: 'Фунафути, Тувалу'
    },
    {
        value: 'Pacific/Galapagos',
        label: 'Pacific/Galapagos (GMT-6)',
        hint: 'Галапагосские о-ва, Эквадор'
    },
    {
        value: 'Pacific/Gambier',
        label: 'Pacific/Gambier (GMT-9)',
        hint: 'о-ва Гамбье, Французская Полинезия'
    },
    {
        value: 'Pacific/Guam',
        label: 'Pacific/Guam (GMT+10)',
        hint: 'Гуам, Гуам'
    },
    {
        value: 'Pacific/Honolulu',
        label: 'Pacific/Honolulu (GMT-10)',
        hint: 'Гонолулу, Соединенные Штаты'
    },
    {
        value: 'Pacific/Kiritimati',
        label: 'Pacific/Kiritimati (GMT+14)',
        hint: 'Киритимати, Кирибати'
    },
    {
        value: 'Pacific/Kosrae',
        label: 'Pacific/Kosrae (GMT+11)',
        hint: 'Косрае, Федеративные Штаты Микронезии'
    },
    {
        value: 'Pacific/Kwajalein',
        label: 'Pacific/Kwajalein (GMT+12)',
        hint: 'Кваджалейн, Маршалловы о-ва'
    },
    {
        value: 'Pacific/Majuro',
        label: 'Pacific/Majuro (GMT+12)',
        hint: 'Маджуро, Маршалловы о-ва'
    },
    {
        value: 'Pacific/Marquesas',
        label: 'Pacific/Marquesas (GMT-9)',
        hint: 'Маркизские о-ва, Французская Полинезия'
    },
    {
        value: 'Pacific/Midway',
        label: 'Pacific/Midway (GMT-11)',
        hint: 'США, Внешние малые о-ва'
    },
    {
        value: 'Pacific/Nauru',
        label: 'Pacific/Nauru (GMT+12)',
        hint: 'Науру'
    },
    {
        value: 'Pacific/Niue',
        label: 'Pacific/Niue (GMT-11)',
        hint: 'Ниуэ'
    },
    {
        value: 'Pacific/Norfolk',
        label: 'Pacific/Norfolk (GMT+11)',
        hint: 'о-в Норфолк'
    },
    {
        value: 'Pacific/Noumea',
        label: 'Pacific/Noumea (GMT+11)',
        hint: 'Нумеа, Новая Каледония'
    },
    {
        value: 'Pacific/Pago_Pago',
        label: 'Pacific/Pago_Pago (GMT-11)',
        hint: 'Паго-Паго, Американское Самоа'
    },
    {
        value: 'Pacific/Palau',
        label: 'Pacific/Palau (GMT+9)',
        hint: 'Палау'
    },
    {
        value: 'Pacific/Pitcairn',
        label: 'Pacific/Pitcairn (GMT-8)',
        hint: 'о-ва Питкэрн'
    },
    {
        value: 'Pacific/Ponape',
        label: 'Pacific/Ponape (GMT+11)',
        hint: 'Понпеи, Федеративные Штаты Микронезии'
    },
    {
        value: 'Pacific/Port_Moresby',
        label: 'Pacific/Port_Moresby (GMT+10)',
        hint: 'Порт-Морсби, Папуа — Новая Гвинея'
    },
    {
        value: 'Pacific/Rarotonga',
        label: 'Pacific/Rarotonga (GMT-10)',
        hint: 'Раротонга, о-ва Кука'
    },
    {
        value: 'Pacific/Saipan',
        label: 'Pacific/Saipan (GMT+10)',
        hint: 'Сайпан, Северные Марианские о-ва'
    },
    {
        value: 'Pacific/Tahiti',
        label: 'Pacific/Tahiti (GMT-10)',
        hint: 'Таити, Французская Полинезия'
    },
    {
        value: 'Pacific/Tarawa',
        label: 'Pacific/Tarawa (GMT+12)',
        hint: 'Тарава, Кирибати'
    },
    {
        value: 'Pacific/Tongatapu',
        label: 'Pacific/Tongatapu (GMT+13)',
        hint: 'Тонгатапу, Тонга'
    },
    {
        value: 'Pacific/Truk',
        label: 'Pacific/Truk (GMT+10)',
        hint: 'Трук, Федеративные Штаты Микронезии'
    },
    {
        value: 'Pacific/Wake',
        label: 'Pacific/Wake (GMT+12)',
        hint: 'США, Внешние малые о-ва'
    },
    {
        value: 'Pacific/Wallis',
        label: 'Pacific/Wallis (GMT+12)',
        hint: 'Уоллис и Футуна'
    }
]
